
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 25 32","fill":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.857 20.571v2.286H4.571v-2.286h2.286zm0-13.714v2.286H4.571V6.857h2.286zm13.714 0v2.286h-2.286V6.857h2.286zM2.286 25.125h6.857v-6.839H2.286v6.839zm0-13.696h6.857V4.572H2.286v6.857zm13.714 0h6.857V4.572H16v6.857zM11.429 16v11.429H0V16h11.429zm9.142 9.143v2.286h-2.286v-2.286h2.286zm4.572 0v2.286h-2.286v-2.286h2.286zm0-9.143v6.857h-6.857v-2.286H16v6.857h-2.286V15.999h6.857v2.286h2.286v-2.286h2.286zM11.429 2.286v11.429H0V2.286h11.429zm13.714 0v11.429H13.714V2.286h11.429z"}})])
          )
        }
      }
    